define('app/views/mighty_slider_carousel',['app/setup', 'jquery.easing', 'jquery.mobileJustTouch', 'mighty-slider'],
  function (takhfifan, easing, mobileJustTouch, mightyslider) {

  takhfifan.MightySliderCarousel = Backbone.View.extend({
    events: {},
    initialize: function () {
        var $win = $(window),
            isTouch = !!('ontouchstart' in window),
            clickEvent = isTouch ? 'tap' : 'click',
            _this = this;

      // Global slider's DOM elements
      var $carousel = this.$el,
          $pagesbar = $('.mSPages', $carousel),
          $frame = $('.frame', $carousel);

      // Calling new mightySlider class
      var slider = new mightySlider($frame, {
        speed: 1000,
        easing: 'easeOutExpo',
        viewport: 'fill',
        startAt: 0,
        // autoScale: 1,

        // Navigation options
        navigation: {
          navigationType: 'basic',
          slideSize: _this.calculator($win.width()),
          isRtl: true
        },

        // Commands options
        commands: {
          buttons: 1
        },

        // Pages options
        pages: {
          pagesBar:       $pagesbar[0],
          activateOn:     clickEvent
        },

        // Dragging options
        dragging: {
          mouseDragging: 0,
          touchDragging: 0
        }
      }).init();
      this.adjustHeight();

      $win.resize(_.debounce(function(){
        _this.adjustHeight();
        slider.set({
          navigation: {
            slideSize: _this.calculator($win.width())
          }
        });
        slider.slideTo(0);
        }, 500)
      );
    },

    /**
     * Calculate the slides width in percent based on the parent's width.
     *
     * @return {String}
     */
    calculator: function(width){
      var percent = '16%';
      if (width <= 480) {
        percent = '33.33%';
      }
      else if (width <= 768) {
        percent = '25%';
      }

      return percent;
    },

    adjustHeight: function () {
      var width = this.$('.mSSlide').first().width(),
          height = width * (288/192);
      this.$('.mSFrame').height(height);
    }
  });
});
